import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import { isProductValidationError } from './find-product-errors';
import type {
  FindProductByParamsResponse,
  ProductRequestParams,
} from './product-api';
import { getCategories, findProductByParams } from './product-api';

export function useGetCategoriesQuery() {
  return useQuery({
    queryKey: ['get-categories'],
    queryFn: getCategories,
  });
}

export function useFindProductByParams(
  params: Omit<ProductRequestParams, 'channel' | 'productType'>,
  options: Omit<
    UseQueryOptions<any, Error, FindProductByParamsResponse>,
    'queryKey' | 'queryFn'
  >
) {
  return useQuery({
    ...options,
    queryKey: ['find-product-by-params', params],
    queryFn: async () => {
      try {
        return await findProductByParams({
          channel: 'ONLINE',
          productType: 'LOAN',
          ...params,
        });
      } catch (error: any) {
        if (isProductValidationError(error)) {
          return {
            maxOrderTotalAmount: error.maxOrderTotalAmount,
            minOrderTotalAmount: error.minOrderTotalAmount,
          };
        }

        throw error;
      }
    },
  });
}
